export default class CategoriaRiassortimento{
    CodiceCategoria;
    Descr;
    UrlImmagine;
    constructor(){}
}